import Swal from "sweetalert2";

/**
 * 🔹 Base function to show any type of alert
 */
const showAlert = ({
  title = "",
  text = "",
  html = "",
  icon = "info", // "success", "error", "warning", "info", "question"
  timer = 0,
  showConfirmButton = true,
  ...options
} = {}) => {
  return Swal.fire({
    title,
    text,
    icon,
    timer,
    showConfirmButton,
    ...options,
  });
};

/**
 * 🔹 Confirmation alert (returns a promise that resolves to true/false)
 */
const confirm = async ({
  title = "Are you sure?",
  text = "Do you want to continue?",
  iconHtml = "?",
  icon = "warning",
  confirmButtonText = "Yes",
  cancelButtonText = "No",
  reverseButtons = true,
  ...options
} = {}) => {
  const result = await Swal.fire({
    title,
    text,
    icon,
    iconHtml,
    showCancelButton: true,
    cancelButtonText,
    confirmButtonText,
    reverseButtons,
    ...options,
  });
  return result.isConfirmed;
};

/**
 * 🔹 Shortcut alert types
 */
const success = (title = "Success", text = "") =>
  showAlert({ icon: "success", title, text, confirmButtonText: "Yes", });

const error = (title = "Error", text = "") =>
  showAlert({ icon: "error", title, text, confirmButtonText: "Yes", });

const info = (title = "Info", text = "") =>
  showAlert({ icon: "info", title, text, confirmButtonText: "Yes", });

const warning = (title = "Warning", text = "") =>
  showAlert({ icon: "warning", title, text, confirmButtonText: "Yes", });


/**
 * 🔹 Export single common service
 */
export const SwalService = {
  showAlert,
  confirm,
  success,
  error,
  info,
  warning,
};
